import {Injectable} from '@angular/core';
import {ExceptionHandlerService} from '../../services/exception-handler-service';
import {AuthService} from '../../services/auth.service';

@Injectable()
export class InternalServerErrorExceptionHandler extends ExceptionHandlerService {

  constructor(private readonly authService: AuthService) {
    super();
  }

  handle(): void {
    this.authService.logout('exceptions.internalServerError.modal.subject', 'exceptions.internalServerError.modal.body');
  }

  isResponsible(httpError: any): boolean {
    return httpError.status === 500;
  }
}
